module.exports = __webpack_public_path__ + "static/img/app-ltd.7cc88cde.png";